<template>
  <masonry
  :cols="{default: 4, 1216: 3}"
  :gutter="{default: '10px', 700: '10px'}"
  class="masonry"
  >
    <div v-for="(item, i) in shuffle(items)" :key="'modal_' + spot_id + '_' + i" class="img-wrap">
      <img class="is-zoomable" :src="baseUrl + item.square.url" :alt="item.caption" @click="handleClick(spot_id, i)">
      <portal to="gallery-images" :order="i">
        <div class="modal" :id="'modal_' + spot_id + '_' + i" :ref="'modal_' + spot_id + '_' + i" :key="'modal_' + spot_id + '_' + i">
          <div class="modal-background" :data-spot-id="spot_id" :data-photo-num="i" @click="prepareClose"></div>
          <div class="modal-container" :ref="'container_' + spot_id + '_' +i">
            <img class="zoomable" v-hammer:doubletap="onDoubleTap" :src="baseUrl + item.image.url" :alt="item.caption">
          </div>
          <div v-if="item.caption" class="modal-footer" :class="{'has-bgcolor': item.caption}">
            <div class="photo-caption">{{item.caption}}</div>
          </div>
          <div class="total-control">
            <button class="prev" @click="prev(spot_id, i)"><span class="icon-keyboard_arrow_left"></span></button>
            <button class="zoomout" @click="zoom(0.75, true)"><span class="icon-zoomout"></span></button>
            <button class="zoomin" @click="zoom(1.25, true)"><span class="icon-zoomin"></span></button>
            <button class="next" @click="next(spot_id, i)"><span class="icon-keyboard_arrow_right"></span></button>
          </div>
          <button class="modal-close is-large" aria-label="close" :data-spot-id="spot_id" :data-photo-num="i" @click="prepareClose"></button>
        </div>
      </portal>
    </div>

  </masonry>
</template>

<script>
import Panzoom from '@panzoom/panzoom'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default {
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    spot_id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      zoomeInstance: null,
      zoomLebel: 1,
      zoomOptions: {
        minScale: 1,
        maxScale: 10,
        contain: 'outside',
        animate: true,
        duration: 200,
        overflow: 'visible'
      },
      window_width: 0,
      viewport: null,
    }
  },
  mounted() {
    this.window_width = document.documentElement.clientWidth
    this.viewport = document.querySelector("meta[name=viewport]")
  },

  computed: {},

  methods: {
    shuffle: function(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let r = Math.floor(Math.random() * (i + 1))
        let tmp = array[i]
        array[i] = array[r]
        array[r] = tmp
      }
      return array
    },
    handleClick: function(id, num){
      const modalId = 'modal_' + id + '_' + num
      const currentModal = document.getElementById(modalId)
      const zoomable = currentModal.querySelector('.zoomable')

      currentModal.classList.add('is-active')
      disableBodyScroll()
      this.scalableViewport(false)

      const self = this
      this.$nextTick(function(){
        self.zoomeInstance = Panzoom(zoomable, self.zoomOptions);
      })
    },
    prepareClose: function(e){
      const spotId = e.currentTarget.getAttribute('data-spot-id')
      const photoNum = e.currentTarget.getAttribute('data-photo-num')
      this.handleClose(spotId, photoNum)
    },
    handleClose: function(id, num){
      const modalId = 'modal_' + id + '_' + num
      const currentModal = document.getElementById(modalId)

      // rest zoom
      this.zoomeInstance.reset()
      currentModal.classList.remove('is-active')
      clearAllBodyScrollLocks()
      this.scalableViewport(true)
    },

    zoom: function(scale) {
      if (scale) {
        this.zoomLebel = this.zoomeInstance.getScale()
        this.zoomeInstance.zoom(this.zoomLebel * scale)
      }
    },
    onDoubleTap: function() {
      if(this.zoomLebel < 2){
        this.zoomLebel = 2
        this.zoomeInstance.zoom(2)
      } else {
        this.zoomLebel = 1
        this.zoomeInstance.reset()
      }
    },

    prev: function(spot_id, num) {
      let prev = num - 1
      if(0 > prev){
        prev = this.items.length - 1
      }
      this.handleClose(spot_id, num)
      this.handleClick(spot_id, prev)
    },
    next: function(spot_id, num) {
      let next = num + 1
      if(this.items.length <= next){
        next = 0
      }
      this.handleClose(spot_id, num)
      this.handleClick(spot_id, next)
    },
    scalableViewport: function(allow=false){
      const content = allow ? 'width=device-width, initial-scale=1.0, user-scalable=yes' : 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      if (!this.viewport){
        this.viewport=document.createElement('meta')
        this.viewport.name = "viewport"
        document.getElementsByTagName('head')[0].appendChild(this.viewport)
      }
      this.viewport.setAttribute('content', content);
    }
  }
}
</script>
<style lang="sass" scoped>
.masonry
  margin-bottom: -15px
.img-wrap
  margin-bottom: 15px
  cursor: pointer
  border-radius: 5px
  overflow: hidden
  .modal-container
    padding: 30px
    max-height: 100%
.vue-pan-zoom-scene
  img
    // cursor: zoom-in
// .masonry
//   line-height: 0
//   column-count: 3
//   column-gap: 10px
//   .img-wrap
//     position: relative
//     width: 100%
//     height: 0
//     padding-top: 100%
//     overflow: hidden
//     img
//       object-fit: cover
//       position: absolute
//       left: 0
//       top: 0
//       border-radius: 5px
</style>
